import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { IconButton, useTheme } from '@mui/material';

import { GEO_MAP_MAX_SCALE, GEO_MAP_MIN_SCALE } from '#shared';

import { useGeoMap } from '../GeoMapProvider';

import { MapControlPanel, controlPanelClasses } from './MapControlPanel';

export const MapZoomControl = () => {
  const { palette } = useTheme();
  const { zoomByStep, projectionRef } = useGeoMap();
  const currentScale = projectionRef.current?.scale() || 1;
  const disabledZoomIn = currentScale >= GEO_MAP_MAX_SCALE;
  const disabledZoomOut = currentScale <= GEO_MAP_MIN_SCALE;

  return (
    <MapControlPanel direction="column" className="TSMED-MapZoomControl-root">
      <IconButton
        className={controlPanelClasses.button}
        onClick={() => zoomByStep(1)}
        disabled={disabledZoomIn}
      >
        <AddIcon fontSize="medium" sx={{ color: palette.common.white }} />
      </IconButton>
      <IconButton
        className={controlPanelClasses.button}
        onClick={() => zoomByStep(-1)}
        disabled={disabledZoomOut}
      >
        <RemoveIcon fontSize="medium" sx={{ color: palette.common.white }} />
      </IconButton>
    </MapControlPanel>
  );
};
